module.exports = __webpack_public_path__ + "static/media/arrow-down.edc877b9.svg";